import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
})
export class ResultComponent implements OnChanges {

  @Input() formData: any;
  @Input() apiData: any;

  result = {
    mediaTotal: 0,
    territoryTotal: 0,
    licenceTotal: 0,
    bur: 0,
    total: 0,
    grandTotal: 0,
  };

  constructor() {}

  get licencePeriod() {
    return this.apiData.licencePeriods[this.formData.licencePeriod];
  }

  filterMediaTypes() {
    return this.apiData.mediaUsages.filter((mediaType) => mediaType.selected);
  }

  filterTerritories() {
    return this.apiData.territoryUsages.filter((territory) => territory.selected);
  }

  calculate() {
    if(this.apiData) {
      let mediaTypes = this.filterMediaTypes();
      let territories = this.filterTerritories();
      let licencePeriod = this.licencePeriod;

      this.result.mediaTotal = 0;
      this.result.territoryTotal = 0;
      this.result.licenceTotal = 0;
      this.result.bur = this.formData.bur;

      if(licencePeriod) {
        this.result.licenceTotal = licencePeriod.value/100;
      }

      if(mediaTypes.length) {
        this.result.mediaTotal = (mediaTypes.map(o=>o.value).reduce((a,c)=>a+c))/100;
      }

      if(territories.length) {
        this.result.territoryTotal = territories.map(o=>o.value).reduce((a,c)=>a+c)/100;
      }

      this.result.grandTotal = (this.result.licenceTotal * this.result.territoryTotal * this.result.mediaTotal) * 100;
      this.result.total = (this.result.bur/100) * this.result.grandTotal;
    } 
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  ngDoCheck() {
    this.calculate();
  }

}
